(function() {
    'use strict';
    angular.module('app')
        .controller('GlobalSearchController', function($q, Shipments, $location) {
            let vm = this;
            vm.searchResultByGroup = [];
            vm.startSearch = startSearch;
            vm.getUrl = getUrl;
            vm.viewMore = viewMore;
            vm.keyword = $location.search().keyword;
            var fields = {
                consignmentId: {
                    label: 'Consignment No',
                    viewFormat: function(row){
                        return row.consignmentId;
                    }
                },
                bookingStatus: {
                    label: 'Booking status',
                    viewFormat: function(row){
                        return row.bookingStatus;
                    }
                },
                custReferences: {
                    label: 'Customer reference no',
                    viewFormat: function(row){
                        return row.customerReferences.length ? row.customerReferences.toString().replace(',',', ') : 'N/A';
                    }
                },
                customerName: {
                    label: 'Customer Name',
                    viewFormat: function(row){
                        if(row.returnAuthorityNumber)
                            return row.sourceAddress.firstName + ' ' + row.sourceAddress.lastName;
                        return row.destinationAddress.firstName + ' ' + row.destinationAddress.lastName;
                    }
                },
                email: {
                    label: 'Email',
                    viewFormat: function(row){
                        if(row.returnAuthorityNumber)
                            return row.sourceAddress.email;
                        return row.destinationAddress.email;
                    }
                },
                phone: {
                    label: 'Phone',
                    viewFormat: function(row){
                        if(row.returnAuthorityNumber)
                            return row.sourceAddress.phone;
                        return row.destinationAddress.phone;
                    }
                },
                returnCustomerName: {
                    label: 'Returned by',
                    viewFormat: function(row){
                        return row.sourceAddress.firstName + ' ' + row.sourceAddress.lastName;
                    }
                },
                returnEmail: {
                    label: 'Returnee\'s email',
                    viewFormat: function(row){
                        return row.sourceAddress.email;
                    }
                },
                returnPhone: {
                    label: 'Returnee\'s phone',
                    viewFormat: function(row){
                        return row.sourceAddress.phone;
                    }
                },
                returnAuthorityNumber: {
                    label: 'Return authority number',
                    viewFormat: function(row){
                        return row.returnAuthorityNumber;
                    }
                }
            };
            const criterias = [{
                name: 'consignmentId',
                onSuccess: groupConsignments
            },{
                name: 'bbConsignmentId',
                onSuccess: bbConsignments
            }, {
                name: 'customerReferences',
                onSuccess: groupCustRef
            }, {
                name: 'returnAuthorityNumber',
                onSuccess: groupReturns
            }, {
                name: 'trackingNumber',
                onSuccess: groupTracking
            }];
            function startSearch() {
                $location.search('keyword', vm.keyword);
                vm.searchResultByGroup = [];
                vm.fetching = true;
                function doAsyncSeries(arr) {
                    return arr.reduce(function (promise, criteria, index) {
                        return promise.then(function(data) {
                            if(data.content.length){
                                criteria.onSuccess(data);
                            }
                            if(index === criterias.length - 1) {
                                return;
                            }
                            return searchShipments(criterias[index + 1].name, vm.keyword);
                        });
                    }, searchShipments(criterias[0].name, vm.keyword));
                }
                doAsyncSeries(criterias).finally(()=>{
                    vm.fetching = false;
                });
            }
            function groupConsignments(data){
                vm.searchResultByGroup.push({
                    header: 'Related consignment number',
                    viewName: 'consignmentId',
                    path: '/shipments/view/{id}',
                    summaryItems: [
                        fields.bookingStatus,
                        fields.custReferences,
                        fields.customerName,
                        fields.email,
                        fields.phone
                    ],
                    data: data
                });
            }

            function bbConsignments(data){
                vm.searchResultByGroup.push({
                    header: 'Related Break bulk Consignment Number',
                    viewName: 'consignmentId',
                    path: '/shipments/view/{id}',
                    summaryItems: [
                        fields.bookingStatus,
                        fields.custReferences,
                        fields.customerName,
                        fields.email,
                        fields.phone
                    ],
                    data: data
                });
            }
            function groupCustRef(data){
                vm.searchResultByGroup.push({
                    header: 'Related customer reference number',
                    viewName: 'customerReferences',
                    path: '/shipments/view/{id}',
                    summaryItems: [
                        fields.bookingStatus,
                        fields.consignmentId,
                        fields.customerName,
                        fields.email,
                        fields.phone
                    ],
                    data: data
                });
            }
            function groupReturns(data){
                vm.searchResultByGroup.push({
                    header: 'Related return authority number',
                    viewName: 'returnAuthorityNumber',
                    path: '/shipments/view/{id}',
                    summaryItems: [
                        fields.bookingStatus,
                        fields.consignmentId,
                        fields.custReferences,
                        fields.returnCustomerName,
                        fields.returnEmail,
                        fields.returnPhone
                    ],
                    data: data
                });
            }

            function groupTracking(data){
                vm.searchResultByGroup.push({
                    header: 'Related tracking number',
                    viewName: 'trackingNumber',
                    path: '/shipments/view/{id}',
                    summaryItems: [fields.bookingStatus,fields.consignmentId,fields.custReferences,fields.customerName,
                        fields.email,fields.phone],
                    data: data
                });
            }
            function getUrl(path, id) {
                return path.replace('{id}', id);
            }
            function searchShipments(criteriaName, val, filters) {
                const defer = $q.defer();
                const pagination = {
                    size: 3,
                    page: 0
                };
                Shipments.getList(data=>{
                    defer.resolve(data);
                }, error=>{
                    defer.reject(error);
                }, angular.extend({
                    [criteriaName]: val,
                }, pagination, filters));

                return defer.promise;
            }
            function viewMore(result) {
                result.page = result.page ? result.page + 1 : 1;
                result.fetching = true;
                searchShipments(result.viewName, vm.keyword, {
                    page: result.page
                }).then(data=>{
                    result.data.content.push(...data.content);
                    result.fetching = false;
                });
            }
            (function () {
                if(vm.keyword){
                    startSearch();
                }
            })();
        });
})();


// WEBPACK FOOTER //
// ./js/controllers/GlobalSearchController.js